import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"

export const BuyAccounts = ({ handleAccounts, accountsTotal, activeAccounts }) => {
    return (
        <VerticalLayout className="feature-card buy-accounts" style={{width:"unset"}}>
            <TextAtom title="Activeer accounts" className={"feature-title"} />
            <HorizontalLayout class="space-between">
                <AccountNumber number={activeAccounts} />
                <AccountHandler action={(value) => handleAccounts(value)} accountsTotal={accountsTotal} />
            </HorizontalLayout>
        </VerticalLayout>
    )
}

export const BuyCards = ({ handleCards, cardsTotal, activeCards }) => {
    return (
        <VerticalLayout className="feature-card buy-cards" style={{ width: "unset"}}>
            <TextAtom title="Koop kaarten" className={"feature-title"} />
            <HorizontalLayout className="space-between">
                <CardsNumber number={activeCards} />
                <CardsHandler action={handleCards} cardsTotal={cardsTotal} />
            </HorizontalLayout>
        </VerticalLayout>
    );
};

const CardsHandler = ({ action, cardsTotal }) => {
    return (
        <HorizontalLayout className="space-between account-handler" style={{ width: "unset" }}>
            <TextAtom title={"Nieuwe kaarten"} className="semi-bold" />
            <HorizontalLayout className="handler-buttons">
                <button
                    onClick={() => action(-1)}
                    className="standard-button grey-background-50 black-color semi-bold up-down-button"
                >
                    -
                </button>
                <TextAtom title={cardsTotal} className="semi-bold" />
                <button
                    onClick={() => action(1)}
                    className="standard-button grey-background-50 black-color semi-bold up-down-button"
                >
                    +
                </button>
            </HorizontalLayout>
        </HorizontalLayout>
    );
};

const CardsNumber = ({ number }) => {
    return (
        <VerticalLayout>
            <TextAtom title={"Aantal kaarten"} />
            <TextAtom title={number} style={{ fontSize: "1.5rem", fontWeight: "600" }} />
        </VerticalLayout>
    );
};


const AccountHandler = ({ action, accountsTotal }) => {
    return (
        <HorizontalLayout class="space-between account-handler" style={{width:"unset"  }}>
            <TextAtom title={"Nieuwe accounts"} className="semi-bold" />
            <HorizontalLayout className="handler-buttons" >
                <button onClick={() => action(-1)} className="standard-button grey-background-50 black-color semi-bold up-down-button">-</button>
                <TextAtom title={accountsTotal} className="semi-bold" />
                <button onClick={() => action(1)} className="standard-button grey-background-50 black-color semi-bold  up-down-button">+</button>
            </HorizontalLayout>
        </HorizontalLayout>)
}
const AccountNumber = ({ number }) => {
    return (
        <VerticalLayout>
            <TextAtom
                title={"Actieve accounts"}
            />
            <TextAtom
                title={number} 
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                />
        </VerticalLayout>
    )
}
